import React, { Component } from "react";

import { Row, Col, Card, CardBody, Container, Table } from "reactstrap";
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { api_route } from "../../Api-config/config";

class SettledTransaction extends Component {
  constructor(props) {
    super(props);
    this.state = {
      breadcrumbItems: [
        { title: "Delisted Stocks", link: "#" },
        { title: "Settled Transaction", link: "#" },
      ],
      tableData: [],
    };
  }

  componentDidMount() {
    this.fetchSettledHistory();
  }

  fetchSettledHistory = () => {
    fetch(api_route + "/dealer/fetchSettledTrasaction", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: 1,
      }),
    })
      .then((response) => response.json())
      .then((json) => {
        this.setState({ tableData: json, isLoading: false });
        console.log(json);
      });
  };

  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <Breadcrumbs
              title="Settled Transaction"
              breadcrumbItems={this.state.breadcrumbItems}
            />

            <Row>
              <Col xs={12}>
                <Card>
                  <CardBody>
                    <div className="table-rep-plugin">
                      <div
                        className="table-responsive mb-0"
                        data-pattern="priority-columns"
                      >
                        <Table
                          id="tech-companies-1"
                          striped
                          bordered
                          responsive
                        >
                          <thead>
                            <tr>
                              <th>Bill ID</th>
                              <th data-priority="1">Bill Generator</th>
                              <th data-priority="3">Shares Company</th>
                              <th data-priority="1">Buyer</th>
                              <th data-priority="3">Seller</th>
                              <th data-priority="3">Quantity</th>
                              <th data-priority="6">Settlement Amount</th>
                              <th data-priority="6">Execution Date</th>
                              <th data-priority="6">Delivery Status</th>
                              <th data-priority="6">Deal Confirmation</th>
                            </tr>
                          </thead>
                          <tbody>
                            {/* {this.state.tableData.length > 0 &&
                              this.state.tableData.map((itm) => (
                                <tr>
                                  <th>{itm.id}</th>
                                  <td>{itm.generator}</td>
                                  <td>{itm.sharesOf}</td>
                                  <td>{itm.buyer}</td>
                                  <td>{itm.seller}</td>
                                  <td>{itm.qty}</td>
                                  <td>{itm.settAmount}</td>
                                  <td>{itm.executionDate}</td>
                                  <td>Settled</td>
                                  <td>
                                    <button className="btn download-bill">
                                      View
                                    </button>
                                  </td>
                                </tr>
                              ))} */}
                          </tbody>
                        </Table>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default SettledTransaction;
